import { render, staticRenderFns } from "./CounterpartyComponent.vue?vue&type=template&id=52f9d131&scoped=true"
import script from "./CounterpartyComponent.vue?vue&type=script&lang=js"
export * from "./CounterpartyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9d131",
  null
  
)

export default component.exports